import { render, staticRenderFns } from "./assItem.vue?vue&type=template&id=4c9928b3&scoped=true"
import script from "./assItem.vue?vue&type=script&lang=js"
export * from "./assItem.vue?vue&type=script&lang=js"
import style0 from "./assItem.vue?vue&type=style&index=0&id=4c9928b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9928b3",
  null
  
)

export default component.exports